<template>
  <div class="container">
    <MdHeaderBar2
      :hide_close="true"
      :hide_back="false"
      :title="{
        isSingle: true,
        primary: info.site_type === 'O' ?
       info.site_idx > 0 && info.status == 'N' ? $t('register.modify_new_open_site') : $t('register.reg_new_open_site') :
       info.site_idx > 0 && info.status == 'N' ? $t('register.modify_general_sale') : $t('register.register_general_sale')
      }" />
    <div class="container scroll-body" style="width:480px;">
      <md-form-group
        :required="true"
        :enable_multi_select="false"
        :label="info.site_type === 'G' ? $t('register.site_name1') : $t('register.site_name')">
        <b-form-input class="input_wrapper input"
                      v-model="info.name" @change="$refs.inputAddress.focus()"
                      :placeholder="info.site_type === 'G' ? $t('more.site_name_placeholder2') : $t('more.site_name_placeholder')" ref="siteName" />
      </md-form-group>
      <md-form-group
        :required="true"
        :enable_multi_select="false"
        :label="$t('register.address')" >
        <div class="align-horizontal mb-2">
          <div class="left_wrapper">
            <b-form-input
              ref="inputAddress"
              v-model="info.address1"
              @change="$refs.inputAddressDetail.focus()"
              class="input_wrapper input mr-1"
              disabled
              :placeholder="$t('more.search_address')"/>
          </div>
          <b-button class="func_btn btn_text btn_right" variant="primary" @click="showAddressPopup=true">
            {{$t('more.address_search')}}
          </b-button>
        </div>
        <b-form-input
          v-model="info.address2"
          ref="inputAddressDetail"
          @change="$refs.inputContactName.focus()"
          class="input_wrapper input"
          :placeholder="$t('more.detail_address_placeholder')" />
      </md-form-group>
      <md-form-group
        :required="true"
        :enable_multi_select="false"
        :label="$t('community.phone')">
        <div class="align-vertical">
          <div v-for="(contact, idx) in info.contact_list"
            class="align-horizontal mb-2">
            <div class="left_wrapper">
              <b-form-input
                v-model="contact.name"
                placeholder="홍길동"
                class="input_wrapper input input_wrapper_md mr-1" />
              <b-form-input
                v-model="contact.phone"
                :formatter="formatPhoneNumber"
                placeholder="010-0000-0000"
                class="input_wrapper input mr-1"
                style="text-align: center"
              />
            </div>
            <b-button class="delete_btn" variant="white" @click="onDelContact(idx)">
              <b-img style="width: 1.3em; height: 1.3rem" :src="require('../../../../assets/image/ic_close3@2x.png')" />
            </b-button>
          </div>
          <div class="align-horizontal" v-if="info.contact_list.length < 5">
            <div class="left_wrapper">
              <b-form-input
                v-model="contact_name"
                ref="inputContactName"
                @change="contact_phone != '' ? onAddContact() : $refs.inputContactPhone.focus()"
                placeholder="홍길동"
                class="input_wrapper input mr-1 input_wrapper_md" />
              <b-form-input
                ref="inputContactPhone"
                v-model="contact_phone"
                :formatter="formatPhoneNumber"
                placeholder="010-0000-0000"
                class="input_wrapper input mr-1"
                style="text-align: center"
                @change="contact_name != '' ? onAddContact() : $refs.inputContactName.focus() "
              />
            </div>
            <b-button v-if="info.contact_list.length < 5" class="func_btn btn btn_text" variant="primary" @click="onAddContact">
              {{$t('admin_member.add')}}
            </b-button>
          </div>
        </div>
      </md-form-group>
      <md-form-group
        :required="true"
        :label="$t('site_detail.site_type')"
        :enable_multi_select="info.site_type !== 'G'">
        <b-button
          variant="white"
          class="toggle_btn toggle_btn_text"
          v-for="(label, idx) in $t('maemul_type')" :key="idx"
          :pressed="getMultipleState($c.MAEMUL_TYPE_MAP_REVERSE[[label]], 'maemul_type')"
          @click="() => {
            (info.site_type !== 'G') ? onMultiSelect($c.MAEMUL_TYPE_MAP_REVERSE[[label]], 'maemul_type') : onSingleSelect($c.MAEMUL_TYPE_MAP_REVERSE[[label]], 'maemul_type')
          }">{{label}}</b-button>
      </md-form-group>
      <md-form-group
        :required="info.site_type === 'O'"
        :enable_multi_select="false" :label="$t('register.complex_info')">
        <div class="align-horizontal mb-2">
          <span class="input_caption mr-2">{{$t('register.total')}}</span>
          <b-form-input
            v-model.number="info.dong_count"
            :formatter="u.formatNumber1"
            @change="$refs.inputHouseCnt.focus()"
            class="input_wrapper input mr-1 input_wrapper_sm"
            style="text-align: center"></b-form-input>
          <span class="input_caption mr-2">{{$t('register.gae_dong')}}</span>
          <span class="input_caption mr-2">{{$t('map.all')}}</span>
          <b-form-input
            ref="inputHouseCnt"
            :formatter="u.formatNumber1"
            v-model.number="info.house_count"
            class="input_wrapper input mr-1 input_wrapper_sm"
            style="text-align: center"></b-form-input>
          <span class="input_caption">{{$t('register.household')}}</span>
        </div>
      </md-form-group>
      <md-form-group
        :label="$t('site_detail.parking_info')" :required="false" :enable_multi_select="true">
        <b-button
          variant="white"
          class="toggle_btn toggle_btn_text"
          v-for="(info, idx) in $t('parking_info')" :key="idx"
          :pressed="getMultipleState(idx, 'parking_type')"
          @click="onMultiSelect(idx,'parking_type')">{{info}}</b-button>
      </md-form-group>

      <template v-if="info.site_type == 'G'">
        <md-form-group
          :label="$t('map.trans_type')"
          :required="true"
          :enable_multi_select="true">
          <b-button
            variant="white"
            class="toggle_btn toggle_btn_text"
            v-for="(v,k,i) in $c.TRANS_TYPE" v-if="v!=''" :key="k"
            :pressed="getMultipleState(i - 1, 'trans_type')"
            @click="() => {
            onMultiSelect(i - 1, 'trans_type');
          }">{{k}}</b-button>
        </md-form-group>
        <div class="align-vertical" v-if="info.trans_type.includes('0')">
          <div class="align-horizontal">
            <md-form-group
              :label="$t('register.trading_price')" labelWidth="160">
              <div class="align-horizontal mb-2">
                <b-form-input class="input_wrapper input mr-1 input_wrapper_sm"
                              v-model="info.sale_price_min"
                              :formatter="u.formatNumber1"
                              :class="{'input_disabled' : (info.site_inquire_price == 'Y')}"
                              :disabled="info.site_inquire_price == 'Y'"></b-form-input>
                <span class="input_caption mr-2">{{$t('room_info_popup.man_won')}}</span>
              </div>
            </md-form-group>
            <div style="margin-right: 10px"></div>
            <md-form-group
              :label="$t('site_detail.collateral')" labelWidth="160">
              <div slot="checkbox_right" class="align-horizontal ml-2" style="font-family: KoreanGD15R; width: 150px; justify-content: flex-end;">
                <md-single-check-box1 :label="$t('site_detail.site_inquire')" v-model="info.site_inquire_price" style="font-family: KoreanGD15R;" />
              </div>
              <div class="align-horizontal mb-2">
                <b-form-input class="input_wrapper input mr-1 input_wrapper_sm"
                              v-model="info.collateral_price"
                              :formatter="u.formatNumber1"
                              :class="{'input_disabled' : (info.site_inquire_price == 'Y')}"
                              :disabled="info.site_inquire_price == 'Y'"></b-form-input>
                <span class="input_caption mr-2">{{$t('room_info_popup.man_won')}}</span>
              </div>
            </md-form-group>
          </div>
          <md-form-group :label="$t('register.trading_fee')" :enable_money_unit="true" label-width="330">
            <div slot="checkbox_right" class="align-horizontal ml-2" style="font-family: KoreanGD15R; width: 150px; justify-content: flex-end;">
              <md-single-check-box1 :label="$t('site_detail.site_inquire_fee')"
                                    v-model="info.fee_site_inquire_price" style="font-family: KoreanGD15R;" />
            </div>
            <div class="align-horizontal">
              <MFSelect
                class="input_wrapper input mr-1 input_wrapper_sm"
                :class="{'input_disabled' : (info.fee_site_inquire_price == 'Y')}"
                :disabled="info.fee_site_inquire_price == 'Y'"
                :drop="true"
                :vmodel="info.fee_trading_type == 2 ? $t('register.none_hit') : info.fee_trading_type == 1 ? $t('register.double_hit') : $t('register.single_hit')"
                @change="(value) => {
                  info.fee_trading_type = value == $t('register.single_hit') ? 0 : value == $t('register.double_hit') ? 1 : 2;
                }"
                :options="$c.FEE_CHARTER_TYPE"
              />
              <!-- <b-form-select
                v-model="info.fee_trading_type"
                :class="{'input_disabled' : (info.fee_site_inquire_price == 'Y')}"
                :disabled="info.fee_site_inquire_price == 'Y'"
                class="input_wrapper input mr-1 input_wrapper_sm">
                <option v-for="(value, idx) in $c.FEE_CHARTER_TYPE" :key="idx" :value="idx + ''">
                  {{value}}
                </option>
              </b-form-select> -->
              <span class="text_bold mr-1">+</span>
              <b-form-input class="input_wrapper input mr-2 input_wrapper_sm"
                            ref="inputFeeCharter"
                            :class="{'input_disabled' : (info.fee_site_inquire_price == 'Y')}"
                            :disabled="info.fee_site_inquire_price == 'Y'"
                            :formatter="u.formatNumber1"
                            v-model="info.fee_trading"/>
              <span class="input_caption">{{$t('register.million_man_won')}}</span>
            </div>
          </md-form-group>
        </div>
        <div class="align-vertical" v-if="info.trans_type.split(',').includes('1')">
          <md-form-group
            :label="$t('map.charter_price')" labelWidth="330">
            <div slot="checkbox" class="align-horizontal ml-2">
              <template v-if="false">
                <md-single-check-box :label="$t('map.safe_charter')" v-model="info.safe_charter" />
                <md-single-check-box :label="$t('map.small_business')" v-model="info.smb" />
              </template>
            </div>
            <div slot="checkbox_right" class="align-horizontal ml-2" style="width: 150px; justify-content: flex-end;">
              <md-single-check-box1 :label="$t('site_detail.site_inquire')" v-model="info.site_inquire_charter" />
            </div>
            <div class="align-horizontal mb-2">
              <b-form-input class="input_wrapper input mr-1 input_wrapper_sm"
                            v-model="info.charter_price_min"
                            :formatter="u.formatNumber1"
                            :class="{'input_disabled' : (info.site_inquire_charter == 'Y')}"
                            :disabled="info.site_inquire_charter == 'Y'"></b-form-input>
              <span class="input_caption mr-2">{{$t('room_info_popup.man_won')}}</span>
              <span v-show="info.site_type == 'O'" class="input_caption mr-2"> ~</span>
              <b-form-input v-show="info.site_type == 'O'" class="input_wrapper input mr-1 input_wrapper_sm" v-model="info.charter_price_max"
                            :formatter="u.formatNumber1"
                            :class="{'input_disabled' : (info.site_inquire_charter == 'Y')}"
                            :disabled="info.site_inquire_charter == 'Y'"></b-form-input>
              <span v-show="info.site_type == 'O'" class="input_caption">{{$t('room_info_popup.man_won')}}</span>
            </div>
          </md-form-group>
          <md-form-group :label="$t('register.charter_fee')" :enable_money_unit="true" label-width="330">
            <div slot="checkbox_right" class="align-horizontal ml-2" style=" width: 150px; justify-content: flex-end;">
              <md-single-check-box1 :label="$t('site_detail.site_inquire_fee')"
                                    v-model="info.fee_site_inquire_charter" />
            </div>
            <div class="align-horizontal">
              <MFSelect
                class="input_wrapper input mr-1 input_wrapper_sm"
                :class="{'input_disabled' : (info.fee_site_inquire_charter == 'Y')}"
                :disabled="info.fee_site_inquire_charter == 'Y'"
                :drop="true"
                :vmodel="info.fee_charter_type == 2 ? $t('register.none_hit') : info.fee_charter_type == 1 ? $t('register.double_hit') : $t('register.single_hit')"
                @change="(value) => {
                  info.fee_charter_type = value == $t('register.single_hit') ? 0 : value == $t('register.double_hit') ? 1 : 2;
                }"
                :options="$c.FEE_CHARTER_TYPE"
              />
              <!-- <b-form-select
                v-model="info.fee_charter_type"
                :class="{'input_disabled' : (info.fee_site_inquire_charter == 'Y')}"
                :disabled="info.fee_site_inquire_charter == 'Y'"
                class="input_wrapper input mr-1 input_wrapper_sm">
                <option v-for="(value, idx) in $c.FEE_CHARTER_TYPE" :key="idx" :value="idx + ''">
                  {{value}}
                </option>
              </b-form-select> -->
              <span class="text_bold mr-1">+</span>
              <b-form-input class="input_wrapper input mr-2 input_wrapper_sm"
                            ref="inputFeeCharter"
                            :formatter="u.formatNumber1"
                            :class="{'input_disabled' : (info.fee_site_inquire_charter == 'Y')}"
                            :disabled="info.fee_site_inquire_charter == 'Y'"
                            v-model="info.fee_charter"/>
              <span class="input_caption">{{$t('register.million_man_won')}}</span>
            </div>
          </md-form-group>
        </div>
        <div class="align-vertical" v-if="info.trans_type.split(',').includes('2')">
          <md-form-group
            :label="$t('map.investment')" labelWidth="330">
            <div slot="checkbox_right" class="align-horizontal ml-2" style=" width: 150px; justify-content: flex-end;">
              <md-single-check-box1 :label="$t('site_detail.site_inquire')" v-model="info.site_inquire_investment" />
            </div>
            <div class="align-horizontal mb-2">
              <b-form-input class="input_wrapper input mr-1 input_wrapper_sm" v-model="info.invest_price_min"
                            :formatter="u.formatNumber1"
                            :class="{'input_disabled' : (info.site_inquire_investment == 'Y')}"
                            :disabled="info.site_inquire_investment == 'Y'"></b-form-input>
              <span class="input_caption mr-2">{{$t('room_info_popup.man_won')}}</span>
              <span v-show="info.site_type == 'O'" class="input_caption mr-2"> ~</span>
              <b-form-input v-show="info.site_type == 'O'" class="input_wrapper input mr-1 input_wrapper_sm" v-model="info.invest_price_max"
                            :formatter="u.formatNumber1"
                            :class="{'input_disabled' : (info.fee_site_inquire_investment == 'Y')}"
                            :disabled="info.fee_site_inquire_investment == 'Y'"></b-form-input>
              <span v-show="info.site_type == 'O'" class="input_caption">{{$t('room_info_popup.man_won')}}</span>
            </div>
          </md-form-group>
          <md-form-group :label="$t('register.invest_fee')" :enable_money_unit="true"
                         label-width="330">
            <div slot="checkbox_right" class="align-horizontal ml-2" style=" width: 150px; justify-content: flex-end;">
              <md-single-check-box1 :label="$t('site_detail.site_inquire_fee')"
                                    v-model="info.fee_site_inquire_investment" />
            </div>
            <div class="align-horizontal">
              <MFSelect
                class="input_wrapper input mr-1 input_wrapper_sm"
                :class="{'input_disabled' : (info.fee_site_inquire_investment == 'Y')}"
                :disabled="info.fee_site_inquire_investment == 'Y'"
                :drop="true"
                :vmodel="info.fee_invest_type == 2 ? $t('register.none_hit') : info.fee_invest_type == 1 ? $t('register.double_hit') : $t('register.single_hit')"
                @change="(value) => {
                  info.fee_invest_type = value == $t('register.single_hit') ? 0 : value == $t('register.double_hit') ? 1 : 2;
                }"
                :options="$c.FEE_CHARTER_TYPE"
              />
              <!-- <b-form-select
                v-model="info.fee_invest_type"
                :class="{'input_disabled' : (info.fee_site_inquire_investment == 'Y')}"
                :disabled="info.fee_site_inquire_investment == 'Y'"
                class="input_wrapper input mr-1 input_wrapper_sm">
                <option v-for="(value, idx) in $c.FEE_CHARTER_TYPE" :key="idx" :value="idx+''">
                  {{value}}
                </option>
              </b-form-select> -->
              <span class="text_bold mr-1">+</span>
              <b-form-input class="input_wrapper input mr-2 input_wrapper_sm"
                            ref="inputFeeCharter"
                            :formatter="u.formatNumber1"
                            :class="{'input_disabled' : (info.fee_site_inquire_investment == 'Y')}"
                            :disabled="info.fee_site_inquire_investment == 'Y'"
                            v-model="info.fee_invest"/>
              <span class="input_caption">{{$t('register.million_man_won')}}</span>
            </div>
          </md-form-group>
        </div>
        <div v-if="info.trans_type.split(',').includes('3')"
             class="align-vertical">
          <div class="align-horizontal">
            <md-form-group :label="$t('map.monthly_rent_deposit')" label-width="160">
              <div class="align-horizontal">
                <b-form-input class="input_wrapper input mr-1 input_wrapper_sm" v-model="info.monthly_rent_min"
                              :formatter="u.formatNumber1"
                              :class="{'input_disabled' : (info.site_inquire_month == 'Y')}"
                              :disabled="info.site_inquire_month == 'Y'"></b-form-input>
                <span class="input_caption">{{$t('room_info_popup.man_won')}}</span>
              </div>
            </md-form-group>
            <div style="margin-right: 10px"></div>
            <md-form-group :label="$t('interest.monthly')" labelWidth="160">
              <div slot="checkbox_right" class="align-horizontal ml-2" style=" width: 150px; justify-content: flex-end;">
                <md-single-check-box1 :label="$t('site_detail.site_inquire')" v-model="info.site_inquire_month" />
              </div>
              <div class="align-horizontal">
                <b-form-input class="input_wrapper input mr-1 input_wrapper_sm" v-model="info.monthly_rent_max"
                              :formatter="u.formatNumber1"
                              :class="{'input_disabled' : (info.site_inquire_month == 'Y')}"
                              :disabled="info.site_inquire_month == 'Y'"></b-form-input>
                <span class="input_caption">{{$t('room_info_popup.man_won')}}</span>
              </div>
            </md-form-group>
          </div>
          <md-form-group :label="$t('register.monthly_fee')" :enable_money_unit="true"
                         label-width="330">
            <div slot="checkbox_right" class="align-horizontal ml-2" style=" width: 150px; justify-content: flex-end;">
              <md-single-check-box1 :label="$t('site_detail.site_inquire_fee')"
                                    v-model="info.fee_site_inquire_month" />
            </div>
            <div class="align-horizontal">
              <MFSelect
                class="input_wrapper input mr-1 input_wrapper_sm"
                :class="{'input_disabled' : (info.fee_site_inquire_month == 'Y')}"
                :disabled="info.fee_site_inquire_month == 'Y'"
                :drop="true"
                :vmodel="info.fee_monthly_type == 2 ? $t('register.none_hit') : info.fee_monthly_type == 1 ? $t('register.double_hit') : $t('register.single_hit')"
                @change="(value) => {
                  info.fee_monthly_type = value == $t('register.single_hit') ? 0 : value == $t('register.double_hit') ? 1 : 2;
                }"
                :options="$c.FEE_CHARTER_TYPE"
              />
              <!-- <b-form-select
                v-model="info.fee_monthly_type"
                :class="{'input_disabled' : (info.fee_site_inquire_month == 'Y')}"
                :disabled="info.fee_site_inquire_month == 'Y'"
                class="input_wrapper input mr-1 input_wrapper_sm">
                <option v-for="(value, idx) in $c.FEE_CHARTER_TYPE" :key="idx" :value="idx+''">
                  {{value}}
                </option>
              </b-form-select> -->
              <span class="text_bold mr-1">+</span>
              <b-form-input class="input_wrapper input mr-2 input_wrapper_sm"
                            ref="inputFeeCharter"
                            :formatter="u.formatNumber1"
                            :class="{'input_disabled' : (info.fee_site_inquire_month == 'Y')}"
                            :disabled="info.fee_site_inquire_month == 'Y'"
                            v-model="info.fee_monthly"/>
              <span class="input_caption">{{$t('register.million_man_won')}}</span>
            </div>
          </md-form-group>
        </div>
        <md-form-group
          :label="$t('map.room_nums')"
          :required="true"
          :enable_multi_select="false">
          <div class="align-horizontal">
            <b-button
              variant="white"
              class="toggle_btn toggle_btn_text"
              v-for="(val, idx) in $c.ROOM_NUM_SELECT.filter((it, _idx) => {return _idx > 0})" :key="idx"
              :pressed="self.info.room_num === idx"
              @click="() => {
                self.info.room_num = idx;
                self.info.room_more = '';
                self.info.room_list = self.info.room_list.map(item => {
                                  item.room = idx;
                                  return item;
                                })
              }">{{val}}</b-button>

            <MFSelect
              class="btn toggle_btn toggle_btn_text ml-2"
              :class="{'active' : self.info.room_num > 4}"
              style="width: fit-content"
              :vmodel="self.info.room_more == '' ? $t('common.select') : self.info.room_more"
              :drop="true"
              @change="(value) => {
                self.info.room_more = value == $t('common.select') ? '' : value
                self.info.room_num = self.info.room_more != '' ? self.info.room_more : self.info.room_num
                self.info.room_list = self.info.room_list.map(item => {
                    item.room = self.info.room_more != '' ? self.info.room_more : self.info.room_num;
                    return item;
                  })
              }"
              :options="more_room_num_list"
            />
            <!-- <b-form-select class="toggle_btn toggle_btn_text ml-2"
                           :class="{'active' : self.info.room_num > 4}"
                           style="width: fit-content"
                           v-model="self.info.room_more"
                           @change="($event) => {
                             self.info.room_num = self.info.room_more != '' ? self.info.room_more : self.info.room_num
                             self.info.room_list = self.info.room_list.map(item => {
                                  item.room = self.info.room_more != '' ? self.info.room_more : self.info.room_num;
                                  return item;
                                })
                           }">
              <option v-for="(val, idx) in more_room_num_list" :key="`room_more_${idx}`" :value="idx > 0 ? val : ''">{{val}}</option>
            </b-form-select> -->
          </div>
        </md-form-group>
        <md-form-group
          :label="$t('map.toilet_nums')"
          :required="true"
          :enable_multi_select="false">
          <div class="align-horizontal">
            <b-button
              variant="white"
              class="toggle_btn toggle_btn_text"
              v-for="(val, idx) in Object.keys($c.MF_TOILET)" :key="idx"
              :pressed="self.info.toilet_num == $c.MF_TOILET[val]"
              @click="() => {self.info.toilet_num = idx + 1; self.info.toilet_more = ''}">{{val}}</b-button>
            <MFSelect
              class="btn toggle_btn toggle_btn_text ml-2"
              :class="{'active' : self.info.toilet_num > 3}"
              style="width: fit-content"
              :vmodel="self.info.toilet_more == '' ? $t('common.select') : self.info.toilet_more"
              :drop="true"
              @change="(value) => {
                self.info.toilet_more = value == $t('common.select') ? '' : value
                self.info.toilet_num = self.info.toilet_more != '' ? self.info.toilet_more : self.info.toilet_num
              }"
              :options="more_toilet_num_list"
            />
            <!-- <b-form-select class="toggle_btn toggle_btn_text ml-2"
                           :class="{'active' : self.info.toilet_num > 3}"
                           style="width: fit-content"
                           v-model="self.info.toilet_more"
                           @change="($event) => {self.info.toilet_num = self.info.toilet_more != '' ? self.info.toilet_more : self.info.toilet_num}">
              <option v-for="(val, idx) in more_toilet_num_list" :key="`toilet_more_${idx}`" :value="idx > 0 ? val : ''">{{val}}</option>
            </b-form-select> -->
          </div>
        </md-form-group>
        <md-form-group
          :label="$t('room_info_popup.veranda')"
          :enable_multi_select="false">
          <div class="align-horizontal">
            <b-button
              variant="white"
              class="toggle_btn toggle_btn_text"
              v-for="(val, idx) in Object.keys($c.VERANDA_UTILITY_NUM)" :key="idx"
              :pressed="self.info.veranda_num == $c.VERANDA_UTILITY_NUM[val]"
              @click="() => {self.info.veranda_num = idx; self.info.veranda_more = ''}">{{val}}</b-button>
            <MFSelect
              class="btn toggle_btn toggle_btn_text ml-2"
              :class="{'active' : self.info.veranda_num > 2}"
              style="width: fit-content"
              :vmodel="self.info.veranda_more == '' ? $t('common.select') : self.info.veranda_more"
              :drop="true"
              @change="(value) => {
                self.info.veranda_more = value == $t('common.select') ? '' : value
                self.info.veranda_num = self.info.veranda_more != '' ? self.info.veranda_more : self.info.veranda_num
              }"
              :options="more_veranda_num_list"
            />
            <!-- <b-form-select class="toggle_btn toggle_btn_text ml-2"
                           :class="{'active' : self.info.veranda_num > 2}"
                           style="width: fit-content"
                           v-model="self.info.veranda_more"
                           @change="($event) => {self.info.veranda_num = self.info.veranda_more != '' ? self.info.veranda_more : self.info.veranda_num}">
              <option v-for="(val, idx) in more_veranda_num_list" :key="`veranda_more_${idx}`" :value="idx > 0 ? val : ''">{{val}}</option>
            </b-form-select> -->
          </div>
        </md-form-group>
        <md-form-group
          :label="$t('room_info_popup.utility_room')"
          :enable_multi_select="false">
          <div class="align-horizontal">
            <b-button
              variant="white"
              class="toggle_btn toggle_btn_text"
              v-for="(val, idx) in Object.keys($c.VERANDA_UTILITY_NUM)" :key="idx"
              :pressed="self.info.utility_room_num == $c.VERANDA_UTILITY_NUM[val]"
              @click="() => {self.info.utility_room_num = idx; self.info.utility_more = ''}">{{val}}</b-button>
            <MFSelect
              class="btn toggle_btn toggle_btn_text ml-2"
              :class="{'active' : self.info.utility_room_num > 2}"
              style="width: fit-content"
              :vmodel="self.info.utility_more == '' ? $t('common.select') : self.info.utility_more"
              :drop="true"
              @change="(value) => {
                self.info.utility_more = value == $t('common.select') ? '' : value
                self.info.utility_room_num = self.info.utility_more != '' ? self.info.utility_more : self.info.utility_room_num
              }"
              :options="more_utility_room_num_list"
            />
            <!-- <b-form-select class="toggle_btn toggle_btn_text ml-2"
                           :class="{'active' : self.info.utility_room_num > 2}"
                           style="width: fit-content"
                           v-model="self.info.utility_more"
                           @change="($event) => {self.info.utility_room_num = self.info.utility_more != '' ? self.info.utility_more : self.info.utility_room_num}">
              <option v-for="(val, idx) in more_utility_room_num_list" :key="`utility_more_${idx}`" :value="idx > 0 ? val : ''">{{val}}</option>
            </b-form-select> -->
          </div>
        </md-form-group>
        <md-form-group :label="$t('site_detail.dup_teras1')">
          <b-button
            variant="white"
            class="toggle_btn toggle_btn_text"
            :pressed="info.duplex == 'N' && info.teras == 'N' || info.duplex == '' && info.teras == ''"
            @click="info.duplex = 'N'; info.teras = 'N';">{{$t('map.none')}}</b-button>
          <b-button
            variant="white"
            class="toggle_btn toggle_btn_text"
            :pressed="info.duplex === 'Y'"
            @click="() => {
              info.duplex = info.duplex == 'Y' ? 'N' : 'Y'
              self.info.room_list = self.info.room_list.map(item => {
                              item.duplex = self.info.duplex == 'Y' ? 'N' : 'Y';
                              return item;
                            })
            }">{{$t('room_info_popup.duplex')}}</b-button>
          <b-button
            variant="white"
            class="toggle_btn toggle_btn_text"
            :pressed="info.teras === 'Y'"
            @click="() => {
              info.teras = info.teras === 'Y' ? 'N' : 'Y'
              self.info.room_list = self.info.room_list.map(item => {
                              item.teras = self.info.teras == 'Y' ? 'N' : 'Y';
                              return item;
                            })
            }">{{$t('site_detail.teras')}}</b-button>
        </md-form-group>
        <md-form-group :label="$t('map.exclusive_area')">
          <div class="align-horizontal">
            <b-form-input class="input_wrapper input mr-2 input_wrapper_sm"
                          v-model="info.room_list[0].square"
                          @input="($event) => {info.room_list[0].pyong = u.calcPyong($event);}"/>
            <span class="input_caption mr-2">{{`${$c.UNIT.square_meter} = `}}</span>
            <b-form-input class="input_wrapper input mr-1 input_wrapper_sm"
                          @input="($event) => {info.room_list[0].square = u.calcSquare($event);}"
                          v-model="info.room_list[0].pyong" />
            <span class="input_caption">{{$t('room_info_popup.pyong')}}</span>
          </div>
        </md-form-group>
        <md-form-group :label="$t('map.real_area')">
          <div class="align-horizontal">
            <b-form-input class="input_wrapper input mr-2 input_wrapper_sm"
                          v-model="info.room_list[1].square"
                          @input="($event) => {info.room_list[1].pyong = u.calcPyong($event);}"/>
            <span class="input_caption mr-2">{{`${$c.UNIT.square_meter} = `}}</span>
            <b-form-input class="input_wrapper input mr-1 input_wrapper_sm"
                          @input="($event) => {info.room_list[1].square = u.calcSquare($event);}"
                          v-model="info.room_list[1].pyong" />
            <span class="input_caption">{{$t('room_info_popup.pyong')}}</span>
          </div>
        </md-form-group>
      </template>
      <div class="align-vertical" v-if="info.site_type == 'O'">
        <md-form-group :label="$t('map.fee')" :required="true" :enable_multi_select_unit="true">
          <b-button
            variant="white"
            class="toggle_btn toggle_btn_text"
            v-for="(val, key, idx) in $c.FEE2" :key="idx" v-if="val!=''"
            :pressed="getMultipleState(val, 'fee_type')"
            @click="onMultiSelect(val, 'fee_type')">{{key}}</b-button>
        </md-form-group>
        <md-form-group v-show="getMultipleState(Object.values($c.FEE2)[0], 'fee_type')"
                       :label="$t('register.r_residence')" >
          <b-form-input class="input_wrapper input mr-2 input_wrapper_sm"
                        @change="$refs.inputFeeCharter.focus()"
                        v-model="info.fee_trading"/>
        </md-form-group>
        <md-form-group v-show="getMultipleState(Object.values($c.FEE2)[1], 'fee_type')"
                       :label="$t('interest.charter')" >
          <div class="align-horizontal">
            <MFSelect
              class="input_wrapper input mr-1 input_wrapper_sm"
              :vmodel="info.fee_charter_type == 2 ? $t('register.none_hit') : info.fee_charter_type == 1 ? $t('register.double_hit') : $t('register.single_hit')"
              :drop="true"
              @change="(value) => {
                info.fee_charter_type = value == $t('register.single_hit') ? 0 : value == $t('register.double_hit') ? 1 : 2;
              }"
              :options="$c.FEE_CHARTER_TYPE"
            />
            <!-- <b-form-select v-model="info.fee_charter_type" class="input_wrapper input mr-1 input_wrapper_sm">
              <option v-for="(value, idx) in $c.FEE_CHARTER_TYPE" :key="idx" :value="idx">
                {{value}}
              </option>
            </b-form-select> -->
            <span class="text_bold mr-1">+</span>
            <b-form-input class="input_wrapper input mr-2 input_wrapper_sm"
                          ref="inputFeeCharterVal"
                          v-model="info.fee_charter"/>
            <span class="input_caption">{{$t('register.million_man_won')}}</span>
          </div>
        </md-form-group>
        <md-form-group v-show="getMultipleState(Object.values($c.FEE2)[2], 'fee_type')"
                       :label="$t('interest.monthly')" >
          <div class="align-horizontal">
            <MFSelect
              class="input_wrapper input mr-1 input_wrapper_sm"
              :vmodel="info.fee_monthly_type == 2 ? $t('register.none_hit') : info.fee_monthly_type == 1 ?  $t('register.double_hit') : $t('register.single_hit')"
              :drop="true"
              @change="(value) => {
                info.fee_monthly_type = value == $t('register.single_hit') ? 0 : value == $t('register.double_hit') ? 1 : 2;
              }"
              :options="$c.FEE_CHARTER_TYPE"
            />
            <!-- <b-form-select v-model="info.fee_monthly_type" class="input_wrapper input mr-1 input_wrapper_sm">
              <option v-for="(value, idx) in $c.FEE_CHARTER_TYPE" :key="idx" :value="idx">
                {{value}}
              </option>
            </b-form-select> -->
            <span class="text_bold mr-1">+</span>
            <b-form-input class="input_wrapper input mr-2 input_wrapper_sm"
                          ref="inputFeeMonthlyVal"
                          v-model="info.fee_monthly"/>
            <span class="input_caption">{{$t('register.million_man_won')}}</span>
          </div>
        </md-form-group>
        <md-form-group v-show="getMultipleState(Object.values($c.FEE2)[3], 'fee_type')"
                       :label="$t('interest.invest')" >
          <div class="align-horizontal">
            <b-form-input class="input_wrapper input mr-2 input_wrapper_sm"
                          ref="inputFeeInvestVal"
                          v-model="info.fee_invest"/>
            <span class="input_caption">{{$t('register.million_man_won')}}</span>
          </div>
        </md-form-group>
      </div>
      <template v-if="info.site_type == 'G'">
        <md-form-group :label="$t('map.elevator')" :required="false">
          <b-button
            variant="white"
            class="toggle_btn toggle_btn_text"
            :pressed="info.elevator == 'Y'"
            @click="info.elevator = 'Y'">{{$t('map.exist')}}</b-button>
          <b-button
            variant="white"
            class="toggle_btn toggle_btn_text"
            :pressed="info.elevator == 'N'"
            @click="info.elevator = 'N'">{{$t('map.none')}}</b-button>
          <b-button
            variant="white"
            class="toggle_btn toggle_btn_text"
            :pressed="info.elevator == 'U'"
            @click="info.elevator = 'U'">{{$t('register.unspecified')}}</b-button>
        </md-form-group>
        <md-form-group :label="$t('site_detail.residence_type')" :required="false">
          <b-button
            variant="white"
            class="toggle_btn toggle_btn_text"
            :pressed="info.residence_type == '1'"
            @click="info.residence_type = '1'">{{$t('site_detail.residence')}}</b-button>
          <b-button
            variant="white"
            class="toggle_btn toggle_btn_text"
            :pressed="info.residence_type == '2'"
            @click="info.residence_type = '2'">{{$t('site_detail.vacancy')}}</b-button>
          <b-button
            variant="white"
            class="toggle_btn toggle_btn_text"
            :pressed="info.residence_type == '0'"
            @click="info.residence_type = '0'">{{$t('register.unspecified')}}</b-button>
        </md-form-group>
      </template>
      <md-form-group :label="info.site_type === 'O' ? $t('map.open_date') : $t('map.open_date2')">
            <b-button @click="onMeal()" style="background-color: white; padding-left: 0px;" slot="checkbox" class="ml-2" v-if="info.site_type === 'O'" >
              <md-single-check-box :label="$t('interest.supply_meal')" v-model="info.supply_meal"/>
            </b-button>
        <div class="align-horizontal">
          <MFSelect
            class="input_wrapper input input_wrapper_sm"
            :vmodel="info.open_date_y"
            :drop="true"
            @change="(value) => {
              info.open_date_y = value;
              info.open_date = info.open_date_y + '-' + u.pad(info.open_date_m, 2) + '-' + u.pad(info.open_date_d, 2)
            }"
            :options="year_list"
            :class="{'input_disabled' : (info.site_type == 'G' && (info.open_date == '' || info.open_date == '0000-00-00'))}"
            :disabled="info.site_type == 'G' && (info.open_date == '' || info.open_date == '0000-00-00')"
          />
          <!-- <b-form-select class="input_wrapper input input_wrapper_sm"
                         v-model="info.open_date_y"
                         @change="($event) => {info.open_date = info.open_date_y + '-' + u.pad(info.open_date_m, 2) + '-' + u.pad(info.open_date_d, 2)}"
                         :options="year_list"
                         :class="{'input_disabled' : (info.site_type == 'G' && (info.open_date == '' || info.open_date == '0000-00-00'))}"
                         :disabled="info.site_type == 'G' && (info.open_date == '' || info.open_date == '0000-00-00')"/> -->
          <span class="input_caption mr-2 ml-2">년</span>
          <MFSelect
            class="input_wrapper input input_wrapper_sm"
            :vmodel="info.open_date_m"
            :drop="true"
            @change="(value) => {
              info.open_date_m = value;
              info.open_date = info.open_date_y + '-' + u.pad(info.open_date_m, 2) + '-' + u.pad(info.open_date_d, 2)
            }"
            :options="month_list"
            :class="{'input_disabled' : (info.site_type == 'G' && (info.open_date == '' || info.open_date == '0000-00-00'))}"
            :disabled="info.site_type == 'G' && (info.open_date == '' || info.open_date == '0000-00-00')"
          />
          <!-- <b-form-select class="input_wrapper input input_wrapper_sm"
                         v-model="info.open_date_m"
                         @change="($event) => {info.open_date = info.open_date_y + '-' + u.pad(info.open_date_m, 2) + '-' + u.pad(info.open_date_d, 2)}"
                         :options="month_list"
                         :class="{'input_disabled' : (info.site_type == 'G' && (info.open_date == '' || info.open_date == '0000-00-00'))}"
                         :disabled="info.site_type == 'G' && (info.open_date == '' || info.open_date == '0000-00-00')"/> -->
          <span class="input_caption mr-2 ml-2">월</span>
          <MFSelect
            class="input_wrapper input input_wrapper_sm"
            :vmodel="info.open_date_d"
            :drop="true"
            @change="(value) => {
              info.open_date_d = value;
              info.open_date = info.open_date_y + '-' + u.pad(info.open_date_m, 2) + '-' + u.pad(info.open_date_d, 2)
            }"
            :options="day_list"
            :class="{'input_disabled' : (info.site_type == 'G' && (info.open_date == '' || info.open_date == '0000-00-00'))}"
            :disabled="info.site_type == 'G' && (info.open_date == '' || info.open_date == '0000-00-00')"
          />
          <!-- <b-form-select class="input_wrapper input input_wrapper_sm"
                         v-model="info.open_date_d"
                         @change="($event) => {info.open_date = info.open_date_y + '-' + u.pad(info.open_date_m, 2) + '-' + u.pad(info.open_date_d, 2)}"
                         :options="day_list"
                         :class="{'input_disabled' : (info.site_type == 'G' && (info.open_date == '' || info.open_date == '0000-00-00'))}"
                         :disabled="info.site_type == 'G' && (info.open_date == '' || info.open_date == '0000-00-00')"/> -->
          <span class="input_caption mr-2 ml-2">일</span>
          <b-button
            v-if="info.site_type == 'G'"
            variant="white"
            class="toggle_btn toggle_btn_text"
            style="margin: 0"
            :pressed="info.open_date == '' || info.open_date == '0000-00-00'"
            @click="() => {info.open_date = (info.open_date == '' || info.open_date == '0000-00-00') ? moment().year() + '-01-01' : ''}">{{$t('register.unspecified')}}</b-button>
        </div>
      </md-form-group>
      <div class="align-vertical md_form_group_unit" v-if="info.site_type === 'O'">
        <div class="align-horizontal" style="justify-content: space-between; align-items: baseline">
          <md-form-group :label="$t('register.inlay_reg')">
            <div slot="checkbox" class="ml-2">
              <md-single-check-box :label="$t('register.private')" v-model="info.inlay_private"/>
            </div>
          </md-form-group>
          <div>
            <b-form-file multiple v-model="inlay_image" class="" accept="image/*" ref="inlayImageBrowser" style="display: none" @input="uploadImage(inlay_image, 'I')"></b-form-file>
            <b-button class="remove_img_btn btn_text btn_right mr-1" variant="secondary" @click="onRemoveImage">
              {{$t('common.delete')}}
            </b-button>
            <b-button class="attach_btn btn_text btn_right" variant="primary" @click="$refs.inlayImageBrowser.$el.querySelector('input[type=file]').click()">
              {{$t('common.attach')}}
            </b-button>
          </div>
        </div>
        <CCarousel
          ref="i_carousel"
          :interval="0"
          v-model="activeInlayIndex"
          cStyle="text-shadow: 1px 1px 2px #333; z-index: 0"
        >
          <b-carousel-slide
            v-for="img in info.inlay_image_url_list"
            :img-src="img"
          >
            <template slot="img">
              <div class="slide-content" style="height: 480px">
                <b-img
                  style="max-width: 100%; height: 100%; object-fit: contain"
                  @click="onGallery('I')"
                  :src="img"
                />
              </div>
            </template>
          </b-carousel-slide>
        </CCarousel>

        <div class="align-vertical" v-if="info.inlay_image_url_list.length > 0" style="position: relative; margin-top: 10px;">
        </div>
      </div>
      <md-form-group
        :label="info.site_type =='G' ? $t('site_detail.memo') : $t('site_detail.memo1')">
        <b-form-textarea
          :placeholder="info.site_type =='G' ? $t('register.memo_guide') : $t('register.memo_guide1')"
          :rows="5"
          ref="inputContent"
          v-model="info.memo"
          style="padding: 5px 10px"
          class="input"></b-form-textarea>
      </md-form-group>
      <div class="align-vertical md_form_group_unit">
        <div class="align-horizontal" style="justify-content: space-between; align-items: baseline">
          <div class="align-vertical">
            <label class="caption" style="margin-bottom: 0">{{$t('register.reg_represent_photo')}}</label>
            <label class="caption_red_desc">{{$t('register.reg_photo_guide')}}</label>
          </div>
          <div>
            <b-form-file v-model="image" multiple class="" accept="image/*" ref="imageBrowser" style="display: none" @input="uploadImage(image, 'P')"></b-form-file>
            <b-button class="remove_img_btn btn_text btn_right mr-1" @click="onDeleteImage"
                      variant="secondary">
              {{$t('common.delete')}}
            </b-button>
            <b-button class="attach_btn btn_text btn_right" variant="primary" @click="$refs.imageBrowser.$el.querySelector('input[type=file]').click()">
              {{$t('common.attach')}}
            </b-button>
          </div>
        </div>
        <div class="align-vertical" v-show="info.image_urls_list.length > 0"
             style="position: relative; margin-top: 10px; width: 450px; margin: auto;">
          <CCarousel
            ref="p_carousel"
            v-model="activeIndex"
            :interval="0"
            cStyle="text-shadow: 1px 1px 2px #333; z-index: 0"
          >
            <b-carousel-slide
              v-for="img in info.image_urls_list"
              :img-src="img"
            >
              <template slot="img">
                <div class="slide-content" style="height: 480px">
                  <b-img
                    style="max-width: 100%; height: 100%; object-fit: contain"
                    @click="onGallery('P')"
                    :src="img"
                  />
                </div>
              </template>
            </b-carousel-slide>
          </CCarousel>
        </div>
      </div>
      <md-form-group :label="$t('site_detail.group_site_set')" :required="false">
        <b-button
          variant="white"
          class="toggle_btn toggle_btn_text"
          :pressed="selected_group != null"
          @click="onSelectGroup">{{selected_group == null ? $t('site_detail.group_share_space') : selected_group.f_name}}</b-button>
        <b-button
          variant="white"
          class="toggle_btn toggle_btn_text"
          :pressed="selected_group == null"
          @click="onSelectPerson">{{$t('site_detail.person_manager')}}</b-button>
      </md-form-group>
      <div class="align-horizontal" style="margin: auto;width: 450px;position: fixed; bottom: 0">
        <b-button class="cancel_btn reg_btn_text no_border_radius" style="flex: 1" variant="secondary" @click="onCancel">
          {{$t('common.cancel')}}
        </b-button>
        <b-button v-if="info.site_idx <=0 || info.status != 'N'" class="temporary_btn reg_btn_text no_border_radius" style="flex: 1" variant="primary" @click="onTemporarySave">
          {{$t('admin_sale_req.temporary_save')}}
        </b-button>
        <b-button class="next_btn reg_btn_text no_border_radius" style="flex: 1" variant="primary" @click="onNextStep">
          {{info.site_type === 'O' ? $t('signup_info.next_step') : $t('register.save')}}
        </b-button>
      </div>
    </div>
    <AddressSearchPopup
      :visible.sync="showAddressPopup"
      @onConfirm="(address, detailAddress) => {
        info.address1 = address;
        info.address2 = detailAddress;
        info.latitude = this.myinfo.tmpLatitude;
        info.longitude = this.myinfo.tmpLongitude;
        info.changeAddress = 'Y';
      }"
    />
    <Gallery
      :visible.sync="galleryPopupShow"
      :src="which == 'I' ? info.inlay_image_url_list : info.image_urls_list"
      :current="which == 'I' ? activeInlayIndex : activeIndex"
    />
    <SelectGroupPopup ref="select_group" />
  </div>
</template>

<script>
import MdHeaderBar2 from "../../../controls/MdHeaderBar2";
import MdFormGroup from "../../../controls/MdFormGroup";
import MFSelect from "../../../controls/mf/MFSelect";
import MdSingleCheckBox from "../../../controls/mf/MdSingleCheckBox";
import MdSingleCheckBox1 from "../../../controls/mf/MdSingleCheckBox1";
import moment from "moment";
import CarouselIndicator from "../../../controls/CarouselIndicator";
import Utils from "../../../../config/utils"
import AddressSearchPopup from "../../../controls/popup/AddressSearchPopup";
import Gallery from "../../../controls/Gallery";
import CCarousel from "../../../controls/CCarousel";
import SelectGroupPopup from "../../../controls/popup/SelectGroupPopup.vue";

export default {
  name: "RegGeneralOrNewOpenSite1",
  components: {
    SelectGroupPopup,
    AddressSearchPopup, CarouselIndicator, MFSelect, MdSingleCheckBox, MdSingleCheckBox1, MdFormGroup, MdHeaderBar2, Gallery, CCarousel},
  data() {
    let oldInfo = null;
    let contactList = [];
    if (this.$route.params.common != null) {
      oldInfo = this.$route.params.common;
    }
    if (this.$route.params.contact_list != null) {
      contactList = this.$route.params.contact_list;
      contactList = contactList.map(item => {
        return {
          name: item.f_name,
          phone: item.f_phone
        };
      });
    }
    let ho_list = null;
    if (this.$route.params.ho_list != null) {
      ho_list = this.$route.params.ho_list;
    }

    let dong_list = [];
    if (this.$route.params.dong_list != null) {
      dong_list = this.$route.params.dong_list;
    }

    let roomList = [
      {
        area: 'E',
        room: -1,
        pyong: '',
        square: '',
        duplex: ''
      },
      {
        area: 'R',
        room: -1,
        pyong: '',
        square: '',
        duplex: ''
      }
    ];
    let roomListIdx = []
    if (this.$route.params.room_list != null) {
      if (oldInfo.f_site_type !== 'O') {
        let _roomList = this.$route.params.room_list;
        _roomList.forEach(item => {
          let idx = null
          if (item.f_area == 'R')
            idx = 1;
          else if (item.f_area == 'E')
            idx = 0;
          if (idx !== null)
            roomList[idx] = {
              area: item.f_area,
              room: parseInt(item.f_room),
              pyong: item.f_area == 'E' ? item.f_exclusive_pyong : item.f_real_pyong,
              square: item.f_area == 'E' ? item.f_exclusive_square : item.f_real_square,
              duplex: item.f_duplex
            };
        });
      } else {
        roomList = this.$route.params.room_list;
        roomList = roomList.map(item => {
          return {
            area: item.f_area,
            room: parseInt(item.f_room),
            pyong: item.f_area == 'E' ? item.f_exclusive_pyong : item.f_real_pyong,
            square: item.f_area == 'E' ? item.f_exclusive_square : item.f_real_square,
            duplex: item.f_duplex
          };
        });
      }
    }
    roomList.forEach((it, idx) => {
      roomListIdx.push(it.room + it.duplex)
    })

    return {
      u: Utils,
      self: this,
      moment: moment,
      dropdownList:[],
      activeIndex: 0,
      activeInlayIndex: 0,
      which: 'I', // I, P,
      inlay_image: null,
      image: null,
      galleryPopupShow: false,
      info: {
        site_idx: oldInfo ? oldInfo.f_idx : -1,
        site_type: oldInfo ? oldInfo.f_site_type : this.$route.params.type === 'New' ? 'O' : 'G',
        name: oldInfo ? oldInfo.f_name : '',
        address1: oldInfo ? oldInfo.f_address1 : '',
        address2: oldInfo ? oldInfo.f_address2 : '',
        latitude: oldInfo ? oldInfo.f_latitude : 0,
        longitude: oldInfo ? oldInfo.f_longitude : 0,
        contact_list: contactList,
        maemul_type: oldInfo ? oldInfo.f_maemul_type : '',
        dong_count: oldInfo && oldInfo.f_dong_count != '0' ? oldInfo.f_dong_count : '',
        house_count: oldInfo && oldInfo.f_house_count != '0' ? oldInfo.f_house_count : '',
        parking_type: oldInfo ? oldInfo.f_parking_type : '',
        trans_type: oldInfo ? oldInfo.f_transaction_type : '',
        room_num: oldInfo && oldInfo.f_room_num? Number(oldInfo.f_room_num) : '',
        room_more: (oldInfo == null || oldInfo && Number(oldInfo.f_room_num) < 5) ? '' : oldInfo.f_room_num,
        // toilet: this._hoInfo != null ? this._hoInfo.toilet : this.toiletNum[0],
        toilet_num: oldInfo && oldInfo.f_toilet_num ? oldInfo.f_toilet_num : '',
        toilet_more: (oldInfo == null || oldInfo &&  Number(oldInfo.f_toilet_num) < 4) ? '' : oldInfo.f_toilet_num,
        veranda_num: oldInfo && oldInfo.f_veranda_num ? oldInfo.f_veranda_num : '',
        veranda_more: (oldInfo == null || oldInfo &&  Number(oldInfo.f_veranda_num) < 3) ? '' : oldInfo.f_veranda_num,
        utility_room_num: oldInfo && oldInfo.f_utility_room_num ? oldInfo.f_utility_room_num : '',
        utility_more: (oldInfo == null || oldInfo &&  Number(oldInfo.f_utility_room_num) < 3) ? '' : oldInfo.f_utility_room_num,
        duplex: oldInfo ? oldInfo.f_duplex : 'N',
        teras: oldInfo ? oldInfo.f_teras : 'N',
        site_inquire_price: oldInfo ? oldInfo.f_site_inquire_price : 'N',
        site_inquire_charter: oldInfo ? oldInfo.f_site_inquire_charter : 'N',
        site_inquire_investment: oldInfo ? oldInfo.f_site_inquire_investment : 'N',
        site_inquire_month: oldInfo ? oldInfo.f_site_inquire_month : 'N',
        fee_site_inquire_price: oldInfo ? oldInfo.f_fee_site_inquire_price : 'N',
        fee_site_inquire_charter: oldInfo ? oldInfo.f_fee_site_inquire_charter : 'N',
        fee_site_inquire_investment: oldInfo ? oldInfo.f_fee_site_inquire_investment : 'N',
        fee_site_inquire_month: oldInfo ? oldInfo.f_fee_site_inquire_month : 'N',
        inlay_private: oldInfo ? oldInfo.f_inlay_private : 'N',
        supply_meal: oldInfo ? oldInfo.f_supply_meal : 'N',

        elevator: oldInfo ? oldInfo.f_elevator : 'U',
        area_type: oldInfo ? oldInfo.f_area_type : '',
        room_list: roomList,
        room_list_r: roomList == null ? [] : roomList.filter(it => it.area == 'R'),
        room_list_e:  roomList == null ? [] : roomList.filter(it => it.area == 'E'),
        room_list_idx: roomListIdx,
        fee_type: oldInfo ? oldInfo.f_fee_type : '',
        open_date: oldInfo ? oldInfo.f_open_date : moment().year() + "-01-01",
        open_date_y: oldInfo && oldInfo.f_open_date != '0000-00-00' ? moment(oldInfo.f_open_date).year() : moment().year(),
        open_date_m: (oldInfo && oldInfo.f_open_date != '0000-00-00' ? moment(oldInfo.f_open_date).month() : 0) + 1,
        open_date_d: oldInfo && oldInfo.f_open_date != '0000-00-00' ? moment(oldInfo.f_open_date).date() : 1,
        temporary_save: 'N',
        drop_off: 'Y',
        house_info: [],
        sale_price_min: oldInfo && oldInfo.f_sale_price_min != '0' ? oldInfo.f_sale_price_min : '',
        sale_price_max: oldInfo && oldInfo.f_sale_price_max != '0' ? oldInfo.f_sale_price_max : '',
        collateral_price: oldInfo && oldInfo.f_collateral_price != '0' && oldInfo.f_collateral_price != null ? oldInfo.f_collateral_price : '',
        charter_price_min: oldInfo && oldInfo.f_charter_price_min != '0' ? oldInfo.f_charter_price_min : '',
        charter_price_max: oldInfo && oldInfo.f_charter_price_max != '0' ? oldInfo.f_charter_price_max : '',
        safe_charter: oldInfo ? oldInfo.f_safe_charter : 'N',
        smb: oldInfo ? oldInfo.f_smb : 'N',
        invest_price_min: oldInfo && oldInfo.f_invest_price_min != '0' ? oldInfo.f_invest_price_min : '',
        invest_price_max: oldInfo && oldInfo.f_invest_price_max != '0' ? oldInfo.f_invest_price_max : '',
        monthly_rent_deposit: oldInfo && oldInfo.f_monthly_rent_deposit != '0' ? oldInfo.f_monthly_rent_deposit : '',
        monthly_rent_min: oldInfo && oldInfo.f_monthly_rent_min != '0' ? oldInfo.f_monthly_rent_min : '',
        monthly_rent_max: oldInfo && oldInfo.f_monthly_rent_max != '0' ? oldInfo.f_monthly_rent_max : '',
        fee_trading: oldInfo && oldInfo.f_fee_trading != '0' ? oldInfo.f_fee_trading : '',
        fee_trading_type: oldInfo ? oldInfo.f_fee_trading_type : 0,
        fee_charter_type: oldInfo ? oldInfo.f_fee_charter_type : 0,
        fee_charter: oldInfo && oldInfo.f_fee_charter != '0' ? oldInfo.f_fee_charter : '',
        fee_invest: oldInfo && oldInfo.f_fee_invest != '0' ? oldInfo.f_fee_invest : '',
        fee_invest_type: oldInfo ? (oldInfo.f_fee_invest_type == null ? 0 : oldInfo.f_fee_invest_type) : 0,
        fee_monthly: oldInfo && oldInfo.f_fee_monthly != '0' && oldInfo.f_fee_monthly != null ? oldInfo.f_fee_monthly : '',
        fee_monthly_type: oldInfo ? (oldInfo.f_fee_monthly_type == null ? 0 : oldInfo.f_fee_monthly_type) : 0,
        residence_type: oldInfo ? oldInfo.f_residence_type : '0',
        inlay_image_url_list: (oldInfo == null || oldInfo.f_inlay_image_url == null) ? [] : oldInfo.f_inlay_image_url.split(',').filter(it => {
          return !Utils.isEmptyOrNull(it)
        }),
        image_urls_list: (oldInfo == null || oldInfo.f_image_urls == null) ? [] : oldInfo.f_image_urls.split(',').filter(it => {
          return !Utils.isEmptyOrNull(it)
        }),
        memo: oldInfo ? oldInfo.f_memo : '',
        status: oldInfo ? oldInfo.f_status : 'N',
        group_idx:oldInfo ? oldInfo.f_group_idx : '',
      },
      dong_list: dong_list,
      ho_list: ho_list,
      contact_name: '',
      contact_phone: '',
      showAddressPopup: false,
      exclusive_area_room: -1,
      exclusive_area_room_idx: -1,
      exclusive_area_room_duplex: 'N',
      exclusive_area_room_m2: '',
      exclusive_area_room_pyong: '',
      real_area_room: -1,
      real_area_room_idx: -1,
      real_area_room_duplex: 'N',
      real_area_room_m2: '',
      real_area_room_pyong: '',
      isDoing: false,
      selected_group: null,
      groupList: [],
    };
  },
  computed: {
    year_list() {
      let list = [];
      for(let ind = 5; ind >= -50; ind--)
        list.push(moment().add(ind, 'year').year());
      return list;
    },
    month_list() {
      let list = [];
      for(let month = 1; month <=12; month ++)
        list.push(month);
      return list;
    },
    day_list() {
      let list = [];
      for(let day = 1; day <=31; day ++)
        list.push(day);
      return list;
    },
    room_dropdown_list() {
      let room_num_list = this.$c.ROOM_NUM_SELECT.filter((it, idx) => {
        return idx > 0
      });
      let room_dropdown_list = [];
      room_num_list.filter((it, idx) => {
        return this.info.room_num.includes(`${idx}`)
      }).forEach(it => {
        room_dropdown_list.push({
          name: it,
          index: room_num_list.indexOf(it),
          duplex: 'N'
        });
        if (this.info.duplex == 'Y') {
          room_dropdown_list.push({
            name: it + '(' +this.$t('room_info_popup.duplex') + ')',
            index: room_num_list.indexOf(it),
            duplex: 'Y'
          });
        }
      });
      return room_dropdown_list;
    },
    more_room_num_list () {
      return [this.$t('common.select')].concat(Utils.getNumList(this.$c.MAX_ROOM_CNT, 5))
    },
    more_toilet_num_list () {
      return [this.$t('common.select')].concat(Utils.getNumList(this.$c.MAX_TOILET_CNT, 4))
    },
    more_utility_room_num_list () {
      return [this.$t('common.select')].concat(Utils.getNumList(this.$c.MAX_UTILITY_ROOM_CNT, 3))
    },
    more_veranda_num_list () {
      return [this.$t('common.select')].concat(Utils.getNumList(this.$c.MAX_VERANDA_CNT, 3))
    },
  },
  async mounted() {
    this.onGetMyGroupList();
    let tempStep = await this.$perf.getInt(this.$c.PREF_PARAMS.TEMP_STEP);
    if (tempStep > 1 && this.info.site_idx > 0) {
      this.onNextStep();
    }
  },
  inject: ["eventBus"],
  methods: {
    changeRoom(index, area_type, original_room_idx, isNew=false) {
      let selected_room = {}
      this.room_dropdown_list.forEach((it, idx) => {
        if (it.index + it.duplex == index)
          selected_room = it
      })
      if (selected_room) {
        if (isNew) {
          if (area_type == 'E'){
            this.exclusive_area_room = selected_room.index;
            this.exclusive_area_room_duplex = selected_room.duplex;
          } else {
            this.real_area_room = selected_room.index;
            this.real_area_room_duplex = selected_room.duplex;
          }
        } else {
          this.info.room_list = this.info.room_list.map((it, index) => {
            if (original_room_idx == index) {
              it.room = selected_room.index;
              it.duplex = selected_room.duplex;
            }
            return it;
          });
        }
      }
    },
    formatPhoneNumber(value) {
      return Utils.formatPhoneNumber(value)
    },
    getMultipleState(item, which)
    {
      return this.info[which].includes(item);
    },
    onAddContact() {
      let { info, contact_name, contact_phone } = this;

      if (info.contact_list.length >= 5) {
        return;
      }

      if (contact_name == '' || contact_phone == '') {
        return;
      }
      Utils.setState(this,{
        info: Object.assign({}, this.info, {
          contact_list: this.info.contact_list.concat([
            { name: contact_name, phone: contact_phone },
          ]),
        }),
        contact_name: '',
        contact_phone: '',
      });
    },
    onDelContact(idx) {
      Utils.setState(this,{
        info: Object.assign({}, this.info, {
          contact_list: this.info.contact_list.filter((it, index) => {
            return idx != index;
          }),
        }),
      });
    },
    onDelAreaInfo(idx) {
      Utils.setState(this, {
        info: Object.assign({}, this.info, {
          room_list: this.info.room_list.filter((it, index) => {
            return idx != index;
          }),
          room_list_idx: this.info.room_list_idx.filter((it, index) => {
            return idx != index;
          }),
        }),
      }, () => {
        this.info.room_list.forEach((it, index) => {
          if (this.dropdownList[index]) {
            this.dropdownList[index].choose(this.room_dropdown_list.findIndex(drop => {
              return drop.duplex == it.duplex && Number(drop.index) == Number(it.room)
            }));
          }
        })
      });
    },
    onUpdateAreaType() {
      let { room_list, area_type } = this.info;
      room_list = room_list.filter(it => {
        return area_type.split(',').includes(it.area);
      });

      Utils.setState(this,{
        info: Object.assign({}, this.info, {
          room_list: room_list
        })
      })
    },
    onUpdateRoomNum() {
      let { room_list, room_num } = this.info;
      room_list = room_list.filter(it => {
        return room_num.split(',').includes(it.room + '');
      });

      Utils.setState(this,{
        info: Object.assign({}, this.info, {
          room_list: room_list
        })
      })
    },
    onAddAreaInfo(area_type) {
      if (this.info.site_type == 'G') {
        return;
      }
      if (area_type == 'E') {
        if (this.exclusive_area_room == -1 ||
          this.exclusive_area_room_m2 == '' ||
          this.exclusive_area_room_pyong == '') {
          return;
        }

        Utils.setState(this,{
          info: Object.assign({}, this.info, {
            room_list: this.info.room_list.concat([
              {
                area: area_type,
                room: this["exclusive_area_room"],
                square: this["exclusive_area_room_m2"],
                pyong: this["exclusive_area_room_pyong"],
                duplex: this["exclusive_area_room_duplex"]
              },
            ]),
            room_list_idx: this.info.room_list_idx.concat([this["exclusive_area_room"] + this["exclusive_area_room_duplex"]]),
          }),
          exclusive_area_room: -1,
          exclusive_area_room_idx: -1,
          exclusive_area_room_duplex: 'N',
          exclusive_area_room_m2: '',
          exclusive_area_room_pyong: '',
        }, () => {
          this.exclusive_area_room = -1;
        });
      } else {
        if (this.real_area_room == -1 ||
          this.real_area_room_m2 == '' ||
          this.real_area_room_pyong == '') {
          return;
        }
        Utils.setState(this, {
          info: Object.assign({}, this.info, {
            room_list: this.info.room_list.concat([
              {
                area: area_type,
                room: this["real_area_room"],
                square: this["real_area_room_m2"],
                pyong: this["real_area_room_pyong"],
                duplex: this["real_area_room_duplex"]
              },
            ]),
            room_list_idx: this.info.room_list_idx.concat([this["real_area_room"] + this["real_area_room_duplex"]]),
          }),
          real_area_room: -1,
          real_area_room_idx: -1,
          real_area_room_duplex: 'N',
          real_area_room_m2: '',
          real_area_room_pyong: '',
        }, () => {
          this.real_area_room = -1;
        });
      }
    },
    onSingleSelect(item, which){
      this.info[which]= item + '';
    },
    onMultiSelect (item, which) {
      item = item + "";
      let oldValue = this.info[which];
      oldValue = oldValue.split(',');
      if (oldValue.indexOf(item + '') > -1) {
        oldValue.splice(oldValue.indexOf(item), 1);
      } else {
        oldValue.push(item);
      }

      if (which == 'trans_type') {
        let fee_array = oldValue.map((it) => {
          return this.$c.FEE_KEY[parseInt(it)]
        })
        Utils.setState(this, {
          info: Object.assign({}, this.info, {
            trans_type: oldValue.join(','),
            fee_type: fee_array.join(',')
          }),
        });
      } else {
        Utils.setState(this,{
          info: Object.assign({}, this.info, {
            [which]: oldValue.join(','),
          }),
        });
      }
    },

    onMeal() {
        if (this.info.supply_meal == 'Y') {
            Utils.showConfirm3(this,
              '<p style="font-size: 20px;">'+this.$t('site_detail.supply_meal_title') +'</p>' +
              '<p style="font-size: 18px; color:#cf0000; margin-bottom: 0px;">'+this.$t('site_detail.supply_meal_content1') +'</p>'+
              '<p style="font-size: 18px; color:#cf0000; margin-bottom: 0px;">'+this.$t('site_detail.supply_meal_content2') +'</p>'
              //'<p style="font-size: 20px; color:#cf0000">‘<span style="text-decoration: underline; font-family: KoreanGD17R;">'+this.$t('site_detail.supply_meal_content2')+'</span>’'+this.$t('site_detail.supply_meal_content3') +'</p>'
            ).then(
              (val) => {
                if(val){

                } else {

                }
              }
            )
        } else {

        }
    },

    onGallery(which) {
      this.galleryPopupShow=true;
      this.which=which;
    },
    onRemoveImage() {
      let { info, activeInlayIndex } = this;
      let image_url_list = info.inlay_image_url_list;

      if (image_url_list.length <= 0) {
        return;
      }
      if (image_url_list.length - 1 < activeInlayIndex) {
        return;
      }
      image_url_list.splice(activeInlayIndex, 1);
      if (image_url_list.length == 0) {
        Utils.setState(this,{
          info: Object.assign({}, this.info, {
            inlay_image_url_list: []
          }),
          activeInlayIndex: 0
        });
        return;
      }
      if (activeInlayIndex > image_url_list.length - 1) {
        activeInlayIndex = image_url_list.length - 1
      }
      Utils.setState(this,{
        info: Object.assign({}, this.info, {
          inlay_image_url_list: image_url_list
        }),
        activeInlayIndex: activeInlayIndex
      });
    },

    uploadImage(files, which) {
      this.which = which;
      Utils.requestUpload(
        this,
        this.$c.API.Upload.image,
        files,
        this.which == 'I' ? '2' : '1'
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          if (this.which == 'I'){
            Utils.setState(this,{
              info: Object.assign({}, this.info, {
                inlay_image_url_list: this.info.inlay_image_url_list.concat(result.data.url)
              }),
            }, () => {
              this.activeInlayIndex = this.info.inlay_image_url_list.length - 1;
            });
          }
          if (this.which == 'P') {
            Utils.setState(this,{
              info: Object.assign({}, this.info, {
                image_urls_list: this.info.image_urls_list.concat(result.data.url)
              }),
            }, () => {
              this.activeIndex = this.info.image_urls_list.length - 1;
            });
          }
        } else {
          Utils.toast(this, result.msg);
        }
      })
        .catch((error) => {
          Utils.toast(this, this.$t('common.upload_image_error'));
        });
    },

    onDeleteImage() {
      let { info, activeIndex } = this;
      let image_url_list = info.image_urls_list;

      if (image_url_list.length <= 0) {
        return;
      }
      if (image_url_list.length - 1 < activeIndex) {
        return;
      }
      image_url_list.splice(activeIndex, 1);
      if (image_url_list.length == 0) {
        Utils.setState(this,{
          info: Object.assign({}, this.info, {
            image_urls_list: []
          }),
          activeIndex: 0
        });
        return;
      }
      if (activeIndex > image_url_list.length - 1) {
        activeIndex = image_url_list.length - 1
      }
      Utils.setState(this,{
        info: Object.assign({}, this.info, {
          image_urls_list: image_url_list
        }),
        activeIndex: activeIndex
      });
    },
    onNextStep() {
      if (this.isDoing) {
        return;
      }

      let regInfo = this.info;
      if (Utils.isEmptyOrNull(regInfo.name)) {
        Utils.toast(this, this.$t('more.site_name_placeholder2'));
        this.$refs.siteName.focus();
        return;
      }
      if (Utils.isEmptyOrNull(regInfo.address1) && Utils.isEmptyOrNull(regInfo.address2)) {
        Utils.toast(this, this.$t('more.address_placeholder'));
        this.$refs.inputAddress.focus();
        return;
      }

      let { contact_name, contact_phone } = this;
      if (contact_name != '' && contact_phone != '' && regInfo.contact_list.length < 5) {
        regInfo.contact_list = regInfo.contact_list.concat([
          { name: contact_name, phone: contact_phone },
        ]);
        Utils.setState(this,{
          info: Object.assign({}, this.info, {
            contact_list: regInfo.contact_list,
          }),
          contact_name: '',
          contact_phone: '',
        });
      }

      if (regInfo.contact_list.length == 0) {
        Utils.toast(this, this.$t('register.contact_placeholder'));
        this.$refs.inputContactName.focus();
        return;
      }
      if (Utils.isEmptyOrNull(regInfo.maemul_type)) {
        Utils.toast(this, this.$t('register.maemul_type_placeholder'));
        return;
      }
      if (this.info.site_type === 'O' && regInfo.dong_count == 0 && regInfo.house_count == 0) {
        Utils.toast(this, this.$t('register.complex_info_placeholder'));
        return;
      }

      if (regInfo.site_type == 'G') {
        if (Utils.isEmptyOrNull(regInfo.trans_type)) {
          Utils.toast(this, this.$t('register.trans_type_placeholder'));
          return;
        }
        if (regInfo.trans_type.split(',').includes('0')) {
          if (Utils.isEmptyOrNull(regInfo.sale_price_min) && Utils.isEmptyOrNull(regInfo.sale_price_max)) {
            if (regInfo.site_inquire_price == 'Y')
            {
              regInfo.sale_price_min = 0;
              regInfo.sale_price_max = 0;
            } else {
              Utils.toast(this, this.$t('register.trans_cost_placeholder'));
              return;
            }
          }
          if (Utils.isEmptyOrNull(regInfo.sale_price_min)) {
            regInfo.sale_price_min = regInfo.sale_price_max;
          }
          if (Utils.isEmptyOrNull(regInfo.sale_price_max)) {
            regInfo.sale_price_max = regInfo.sale_price_min;
          }
        } else {
          regInfo.sale_price_min = 0;
          regInfo.sale_price_max = 0;
        }
        if (regInfo.trans_type.split(',').includes('1')) {
          if (Utils.isEmptyOrNull(regInfo.charter_price_min) && Utils.isEmptyOrNull(regInfo.charter_price_max)) {
            if (regInfo.site_inquire_charter == 'Y'){
              regInfo.charter_price_min = 0;
              regInfo.charter_price_max = 0;
            } else {
              Utils.toast(this, this.$t('register.trans_cost_placeholder'));
              return;
            }
          }
          if (Utils.isEmptyOrNull(regInfo.charter_price_min)) {
            regInfo.charter_price_min = regInfo.charter_price_max;
          }
          if (Utils.isEmptyOrNull(regInfo.charter_price_max)) {
            regInfo.charter_price_max = regInfo.charter_price_min;
          }
        } else {
          regInfo.charter_price_min = 0;
          regInfo.charter_price_max = 0;
        }
        if (regInfo.trans_type.split(',').includes('2')) {
          if (Utils.isEmptyOrNull(regInfo.invest_price_min) && Utils.isEmptyOrNull(regInfo.invest_price_max)) {
            if (regInfo.site_inquire_investment == 'Y'){
              regInfo.invest_price_min = 0;
              regInfo.invest_price_max = 0;
            } else {
              Utils.toast(this, this.$t('register.trans_cost_placeholder'));
              return;
            }
          }
          if (Utils.isEmptyOrNull(regInfo.invest_price_min)) {
            regInfo.invest_price_min = regInfo.invest_price_max;
          }
          if (Utils.isEmptyOrNull(regInfo.invest_price_max)) {
            regInfo.invest_price_max = regInfo.invest_price_min;
          }
        } else {
          regInfo.invest_price_min = 0;
          regInfo.invest_price_max = 0;
        }
        if (regInfo.trans_type.split(',').includes('3')) {
          if ((Utils.isEmptyOrNull(regInfo.monthly_rent_min) || Utils.isEmptyOrNull(regInfo.monthly_rent_max))) {
            if (regInfo.site_inquire_month == 'Y') {
              regInfo.monthly_rent_min = 0;
              regInfo.monthly_rent_max = 0;
            } else {
              Utils.toast(this, this.$t('register.trans_cost_placeholder'));
              return;
            }
          }
        } else {
          regInfo.monthly_rent_min = 0;
          regInfo.monthly_rent_max = 0;
        }

        if (Utils.isEmptyOrNull(regInfo.room_num)) {
          Utils.toast(this, this.$t('register.room_num_placeholder'));
          return;
        }
        if (Utils.isEmptyOrNull(regInfo.toilet_num)) {
          Utils.toast(this, this.$t('register.toilet_num_placeholder'));
          return;
        }
        /*
        if (Utils.isEmptyOrNull(regInfo.veranda_num)) {
          Utils.toast(this, this.$t('register.veranda_num_placeholder'));
          return;
        }
        if (Utils.isEmptyOrNull(regInfo.utility_room_num)) {
          Utils.toast(this, this.$t('register.utility_room_num_placeholder'));
          return;
        }
        if (Utils.isEmptyOrNull(regInfo.elevator)) {
          Utils.toast(this, this.$t('register.elevator_placeholder'));
          return;
        }*/
        //--------------면적관련 새로수정된 부분------------//
        // if (regInfo.room_list.filter((item, idx) => {
        //   if (item.room !== -1 && !['0', 0, ''].includes(item.square) && !['0', 0, ''].includes(item.pyong))
        //     return item;
        // }).length < 1) {
        //   Utils.toast(this, this.$t('register.area_info_placeholder'));
        //   return;
        // }
        // regInfo.room_list = regInfo.room_list.filter((item, idx) => {
        //   if (item.room !== -1 && !['0', 0, ''].includes(item.square) && !['0', 0, ''].includes(item.pyong))
        //     return item;
        // });
        //-----------------------------------------------//
      }
      /*
      면적관련 이전 처리 코드(새 버전에서는 이용안함)
      if (Utils.isEmptyOrNull(regInfo.area_type)) {
        Utils.toast(this, this.$t('register.area_placeholder'));
        return;
      }
      let { exclusive_area_room, exclusive_area_room_duplex, exclusive_area_room_m2, exclusive_area_room_pyong } = this;
      if (exclusive_area_room != -1 && exclusive_area_room_m2 != '' && exclusive_area_room_pyong != '') {
        regInfo.room_list = regInfo.room_list.concat([
          {
            area: 'E',
            room: exclusive_area_room,
            square: exclusive_area_room_m2,
            pyong: exclusive_area_room_pyong,
            duplex: exclusive_area_room_duplex
          },
        ]);

        Utils.setState(this,{
          info: Object.assign({}, this.info, {
            room_list: regInfo.room_list,
          }),
          exclusive_area_room: -1,
          exclusive_area_room_duplex: 'N',
          exclusive_area_room_m2: '',
          exclusive_area_room_pyong: '',
        });
      }

      let { real_area_room, real_area_room_duplex, real_area_room_m2, real_area_room_pyong } = this;
      if (real_area_room != -1 && real_area_room_m2 != '' && real_area_room_pyong != '') {
        regInfo.room_list = regInfo.room_list.concat([
          {
            area: 'R',
            room: real_area_room,
            square: real_area_room_m2,
            pyong: real_area_room_pyong,
            duplex: real_area_room_duplex
          },
        ]);

        Utils.setState(this,{
          info: Object.assign({}, this.info, {
            room_list: regInfo.room_list,
          }),
          real_area_room: -1,
          real_area_room_duplex: 'N',
          real_area_room_m2: '',
          real_area_room_pyong: '',
        });
      }

      if (regInfo.room_list.length < 1) {
        Utils.toast(this, this.$t('register.area_info_placeholder'));
        return;
      }*/
      /* 수수료관련 이전 처리코드(새 버전에서는 이용안함)
      if (Utils.isEmptyOrNull(regInfo.fee_type)) {
        Utils.toast(this, this.$t('register.fee_type_placeholder'));
        return;
      }
      if (regInfo.fee_type.includes('T')) {
        if (Utils.isEmptyOrNull(regInfo.fee_trading)) {
          Utils.toast(this, this.$t('register.fee_info_placeholder'));
          return;
        }
      }
      if (regInfo.fee_type.includes('C')) {
        if (Utils.isEmptyOrNull(regInfo.fee_charter)) {
          regInfo.fee_charter = '0';
          // Utils.toast(this, this.$t('register.fee_info_placeholder'));
          // return;
        }
      }
      if (regInfo.fee_type.includes('I')) {
        if (Utils.isEmptyOrNull(regInfo.fee_invest)) {
          Utils.toast(this, this.$t('register.fee_info_placeholder'));
          return;
        }
      }*/
      //--------------수수료관련 새로수정된 부분------------//
      // if (regInfo.site_type == 'G') {
        if (regInfo.fee_type.includes('T')) {
          if (regInfo.fee_site_inquire_price == 'Y'){
            regInfo.fee_trading = 0;
          } else {
            if (Utils.isEmptyOrNull(regInfo.fee_trading)) {
              regInfo.fee_trading = 0;
            }
          }
        }
        if (regInfo.fee_type.includes('C')) {
          if (regInfo.fee_site_inquire_charter == 'Y'){
            regInfo.fee_charter = 0;
          } else {
            if (Utils.isEmptyOrNull(regInfo.fee_charter)) {
              regInfo.fee_charter = 0;
            }
          }
        }
        if (regInfo.fee_type.includes('I')) {
          if (regInfo.fee_site_inquire_investment == 'Y'){
            regInfo.fee_invest = 0;
          } else {
            if (Utils.isEmptyOrNull(regInfo.fee_invest)) {
              regInfo.fee_invest = 0;
            }
          }
        }
        if (regInfo.fee_type.includes('M')) {
          if (regInfo.fee_site_inquire_month == 'Y'){
            regInfo.fee_monthly = 0;
          } else {
            if (Utils.isEmptyOrNull(regInfo.fee_monthly)) {
              regInfo.fee_monthly = 0;
            }
          }
        }
      // } else {
        if (Utils.isEmptyOrNull(regInfo.fee_type)) {
          Utils.toast(this, this.$t('register.fee_type_placeholder'));
          return;
        }
        if (regInfo.trans_type.includes('T')) {
          if (Utils.isEmptyOrNull(regInfo.fee_trading)) {
            regInfo.fee_trading = 0;
          }
        }
        if (regInfo.trans_type.includes('C')) {
          if (Utils.isEmptyOrNull(regInfo.fee_charter)) {
            regInfo.fee_charter = 0;
          }
        }
        if (regInfo.trans_type.includes('I')) {
          if (Utils.isEmptyOrNull(regInfo.fee_invest)) {
            regInfo.fee_invest = 0;
          }
        }
        if (regInfo.trans_type.includes('M')) {
          if (Utils.isEmptyOrNull(regInfo.fee_monthly)) {
            regInfo.fee_monthly = 0;
          }
        }
      // }
      //------------------------------------------------//

      if (regInfo.image_urls_list.length > 0) {
        regInfo.image_urls = regInfo.image_urls_list.join(',');
      }
      if (regInfo.inlay_image_url_list.length > 0) {
        regInfo.inlay_image_url = regInfo.inlay_image_url_list.join(',');
      }
      if (regInfo.contact_list.length > 0) {
        regInfo.contacts = JSON.stringify(regInfo.contact_list);
      }

      if (regInfo.room_list.length > 0) {
        regInfo.rooms = JSON.stringify(regInfo.room_list);
      }
      if (regInfo.changeAddress == 'Y') {

      } else {
          regInfo.changeAddress = 'N';
      }
      if (regInfo.site_type === 'O') {
        console.log("Group Info")
        console.log(this.selected_group)
        console.log("Group Info")
        this.$router.push({
          name: 'RegNewOpenSite2',
          params: {
            reg_info: regInfo,
            ho_list: this.ho_list,
            dong_list: this.dong_list,
            selected_group: this.selected_group,
          }}, ()=>{
          this.eventBus.$emit('refresh_from_step1')
        });
      } else {
        this.isDoing = true;
        regInfo.temporary_save = 'N';
        regInfo.drop_off = 'N';
        if (this.selected_group) {
          regInfo.group_idx = this.selected_group.f_idx;
        } else {
          regInfo.group_idx = '';
        }
        Utils.requestPost(
          regInfo.site_idx > -1 ? this.$c.API.Site.updateSite_app : this.$c.API.Site.addSite_app,
          regInfo
        ).then(result => {
          if (result.code === this.$c.API_RES_CODE.SUCCESS) {
            // this.eventBus.$emit('sale_modify', regInfo.site_idx);
            this.isDoing = false;
            Utils.toast(this, this.$t('common.save_success'));
            if (regInfo.site_idx > -1) {
              //일반매물 수정인 경우
              this.$router.back();
              //다중중복 이슈로 뒤로가기 한번더 해줌
              if (regInfo.changeAddress == 'Y') {
                this.$router.back();
              }
            } else {
              //일반매물 새로 등록인 경우
              this.$router.back();
              //다중중복 이슈로 뒤로가기 한번더 해줌
              if (regInfo.changeAddress == 'Y') {
                this.$router.back();
              }
            }
          } else {
            Utils.toast(this, result.msg);
          }
        });
      }
    },

    onTemporarySave(e,goBack = false) {
      let regInfo = this.info;
      let { contact_name, contact_phone } = this;
      if (contact_name != '' && contact_phone != '' && regInfo.contact_list.length < 5) {
        regInfo.contact_list = regInfo.contact_list.concat([
          { name: contact_name, phone: contact_phone },
        ]);
        Utils.setState(this, {
          info: Object.assign({}, this.info, {
            contact_list: regInfo.contact_list,
          }),
          contact_name: '',
          contact_phone: '',
        });
      }

      if (regInfo.image_urls_list.length > 0) {
        regInfo.image_urls = regInfo.image_urls_list.join(',');
      }
      if (regInfo.inlay_image_url_list.length > 0) {
        regInfo.inlay_image_url = regInfo.inlay_image_url_list.join(',');
      }
      if (regInfo.contact_list.length > 0) {
        regInfo.contacts = JSON.stringify(regInfo.contact_list);
      }
      let { exclusive_area_room, exclusive_area_room_duplex, exclusive_area_room_m2, exclusive_area_room_pyong } = this;

      if (exclusive_area_room != -1 && exclusive_area_room_m2 != '' && exclusive_area_room_pyong != '') {

        regInfo.room_list = regInfo.room_list.concat([
          {
            area: 'E',
            room: exclusive_area_room,
            square: exclusive_area_room_m2,
            pyong: exclusive_area_room_pyong,
            duplex: exclusive_area_room_duplex
          },
        ]);

        Utils.setState(this,{
          info: Object.assign({}, this.info, {
            room_list: regInfo.room_list,
          }),
          exclusive_area_room: -1,
          exclusive_area_room_duplex: 'N',
          exclusive_area_room_m2: '',
          exclusive_area_room_pyong: '',
        });
      }

      if (this.state.selected_group) {
        regInfo.group_idx = this.selected_group.f_idx;
      } else {
        regInfo.group_idx = '';
      }

      let { real_area_room, real_area_room_duplex, real_area_room_m2, real_area_room_pyong } = this;

      if (real_area_room != -1 && real_area_room_m2 != '' && real_area_room_pyong != '') {

        regInfo.room_list = regInfo.room_list.concat([
          {
            area: 'R',
            room: real_area_room,
            square: real_area_room_m2,
            pyong: real_area_room_pyong,
            duplex: real_area_room_duplex
          },
        ]);

        Utils.setState(this, {
          info: Object.assign({}, this.info, {
            room_list: regInfo.room_list,
          }),
          real_area_room: -1,
          real_area_room_duplex: 'N',
          real_area_room_m2: '',
          real_area_room_pyong: '',
        });
      }

      if (regInfo.room_list.length > 0) {
        regInfo.rooms = JSON.stringify(regInfo.room_list);
      }
      regInfo.temporary_save = 'Y';
      regInfo.drop_off = 'N';
      Utils.requestPost(
        regInfo.site_idx > -1 && regInfo.status != 'N' ? this.$c.API.Site.updateSite : this.$c.API.Site.addSite,
        regInfo
      ).then(async result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          this.info.site_idx = result.data.site_idx;
          this.info.status = 'P';

          this.$perf.setInt(this.$c.PREF_PARAMS.TEMP_STEP, 1);

          if (goBack) {
            this.$router.back();
          } else {
            Utils.toast(this, this.$t('common.temporary_save_success'));
          }
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    onCancel() {
        this.$router.back();
    },

    onSelectGroup() {
      this.$refs.select_group.show(
        this.info.f_name,
        this.info.address1,
        (group, gotoGroup = false) => {
          console.log(group)
          Utils.setState(this,{
            selected_group: group,
          });
        }
      );
    },

    onSelectPerson() {
      Utils.setState(this,{
        selected_group : null
      });
    },

    onGetMyGroupList() {
      Utils.requestGet(this.$c.API.Group.getMyGroupList, []).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          console.log(this.info.group_idx)
          console.log(result.data)
          if (this.info.group_idx != '') {
            const group = result.data.filter((it) => {
              return it.f_idx == this.info.group_idx
            });
            if (group) {
              Utils.setState(this,{
                selected_group : group[0]
              });
            }
          }
        } else
          Utils.toast(this, result.msg);
      });
    }
  },
}
</script>

<style scoped lang="scss">
  @import "../../../../assets/css/main/more/RegNewOpenSite1";

  $btn_right_width: 75px;
  $input_wrapper_sm_width: 100px;
  $input_wrapper_md_width: 150px;
  $input_wrapper_lg_width: 300px;

  .form-control:disabled {
    background-color: white;
  }
  .scroll-body {
    //overflow: auto;
    //padding-top: $md_header_height;
    padding-top: 80px;
    padding-bottom: 80px;
  }
  .btn_right {
    width: $btn_right_width;
  }
  .left_wrapper {
    width: calc(100% - #{$btn_right_width});
    display: flex;
    flex-direction: row;
  }
  .input_wrapper_sm {
    width: $input_wrapper_sm_width;
    text-align: center;
  }
  .input_wrapper_md {
    width: $input_wrapper_md_width;
    text-align: center;
  }
  .input_wrapper_lg {
    width: $input_wrapper_lg_width;
    text-align: center;
  }
  .input_disabled {
    background-color: #E1E1E1!important;
    color: #E1E1E1!important;
  }
  .option_list {
    font-size: 22px;
    font-family: "KoreanGD14R";
    text-align: center;
    width: $input_wrapper_md_width;
  }

</style>



// WEBPACK FOOTER //
// src/components/contents/main/more/RegGeneralOrNewOpenSite1.vue